import React, { FC } from "react";
import { HeaderGroup } from "react-table";
import classNames from "classnames";

import { StreamLineIcon } from "../../../../SvgIcon/StreamLineIcon";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

interface DoctorsListHeadingItemProps {
  column: HeaderGroup<InsuranceDoctorDto>;
}

export const DoctorsListHeadingItem: FC<DoctorsListHeadingItemProps> = (
  props
) => {
  const { column } = props;
  // @ts-expect-error TS2339
  const {getHeaderProps, render, getSortByToggleProps, isSorted, isSortedDesc, canSort, id: rowId,} = column;
  return (
    <th
      {...getHeaderProps(getSortByToggleProps())}
      className={classNames({
        doctorsListHeadings__cellName: rowId === "name",
        doctorsListHeadings__cellDepartment: rowId === "department",
        doctorsListHeadings__cellCenters: rowId === "centers",
        doctorsListHeadings__cellPrice: rowId === "price",
        doctorsListHeadings__cellDate: rowId === "date",
      })}
    >
      <span
        className={classNames("doctorsListHeadings__cellLabel", {
          "doctorsListHeadings__cellLabel--sortable": canSort,
          "doctorsListHeadings__cellLabel--sorted": isSorted,
        })}
      >
        {render("Header")}
        {isSorted && (
          <span className="doctorsListHeadings__icon">
            {isSortedDesc ? (
              <StreamLineIcon iconName="s-arrow-down" />
            ) : (
              <StreamLineIcon iconName="s-arrow-up" />
            )}
          </span>
        )}
      </span>
    </th>
  );
};
